<template>
  <a-button type="primary" v-bind="$attrs" @click="addVisible = true"
    >新增角色</a-button
  >
  <a-modal
    :open="addVisible"
    title="新增角色"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirm-loading="confirmLoading"
  >
    <a-form
      ref="formRef"
      :model="formState"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="rules"
    >
      <form-select
        label="选择系统"
        name="menuSystemId"
        :showSearch="true"
        :filterOption="filterOption"
        v-model:value="formState.menuSystemId"
      >
        <a-select-option
          :value="item.id"
          :name="item.name"
          v-for="(item, key) in sysData.systems"
          :key="key"
        >
          {{ item.name }}
        </a-select-option>
      </form-select>
      <a-form-item label="输入角色名称" name="name">
        <a-input
          v-model:value="formState.name"
          placeholder="请输入"
          autocomplete="off"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { reactive, ref, toRefs, inject, onMounted } from 'vue'
import { common_info_get } from 'server/modules/351.js'
import { message } from 'ant-design-vue'
export default {
  setup() {
    const { systems, addRoleInfo, initData } = inject('state')
    const formRef = ref()
    const addVisible = ref(false)
    const confirmLoading = ref(false)
    const formState = reactive({
      name: '',
      menuSystemId: null
    })
    const rules = reactive({
      menuSystemId: [{ trigger: 'blur', type: 'number' }],
      name: [
        {
          required: true,
          message: '请输入角色名称'
        }
      ]
    })

    const sysData = reactive({
      roles: [],
      systems: []
    })

    function fetchBase() {
      common_info_get().then(res => {
        sysData.roles = res.data.role
        sysData.systems = res.data.menuSystem
        // const defaultSystem = res.data.menuSystem.find(item => {
        //   return item.systemCode === 'auth'
        // })
        // state.systemId = defaultSystem.id
      })
    }

    onMounted(() => {
      fetchBase()
    })
    const filterOption = (input, option) => {
      return option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    const fn = reactive({
      handleOk: () => {
        confirmLoading.value = true
        formRef.value
          .validate()
          .then(() => {
            addRoleInfo(formState).then(res => {
              if (res.success) {
                setTimeout(() => {
                  formRef.value.resetFields()
                  addVisible.value = false
                  confirmLoading.value = false
                })
                initData()
                message.success(res.retInfo)
              } else {
                message.error(res.retInfo)
                confirmLoading.value = false
              }
            })
          })
          .catch(error => {
            console.log('error', error)
            confirmLoading.value = false
          })
      },
      handleCancel: () => {
        formRef.value.resetFields()
        addVisible.value = false
      }
    })

    return {
      formRef,
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      other: '',
      formState,
      addVisible,
      rules,
      filterOption,
      // ...toRefs(state),
      systems,
      confirmLoading,
      ...toRefs(fn),
      sysData
    }
  }
}
</script>
<style lang="scss" scoped></style>
